import { useCallback, useReducer } from 'react';
import feedbackReducer, { initialFeedbackReducerState } from './feedbackReducer';
import { SET_CONTACT_CONSENT_ACTION, SET_FEEDBACK_ACTION, SET_RATING_ACTION, SET_SURVEY_CONTACT_ID_ACTION, CLOSE_SURVEY_ACTION, INCREMENT_SURVEY_STEP_ACTION, RESET_SURVEY_ACTION } from './constants';
const useFeedbackReducer = () => {
  const [feedbackState, dispatch] = useReducer(feedbackReducer, initialFeedbackReducerState);
  const setRating = useCallback(rating => dispatch({
    type: SET_RATING_ACTION,
    payload: {
      rating
    }
  }), []);
  const setFeedback = useCallback(feedback => dispatch({
    type: SET_FEEDBACK_ACTION,
    payload: {
      feedback
    }
  }), []);
  const setSurveyContactId = useCallback(surveyContactId => dispatch({
    type: SET_SURVEY_CONTACT_ID_ACTION,
    payload: {
      surveyContactId
    }
  }), []);
  const setContactConsent = useCallback(contactConsent => dispatch({
    type: SET_CONTACT_CONSENT_ACTION,
    payload: {
      contactConsent
    }
  }), []);
  const incrementSurveyStep = useCallback(() => dispatch({
    type: INCREMENT_SURVEY_STEP_ACTION
  }), []);
  const closeSurvey = useCallback(() => dispatch({
    type: CLOSE_SURVEY_ACTION
  }), []);
  const resetSurvey = useCallback(() => dispatch({
    type: RESET_SURVEY_ACTION
  }), []);
  return {
    feedbackState,
    setRating,
    setFeedback,
    setSurveyContactId,
    setContactConsent,
    closeSurvey,
    incrementSurveyStep,
    resetSurvey
  };
};
export default useFeedbackReducer;